import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner'
import purchaseOrderConverter from '../../../../middlewares/Warehouse/xtnsv-po-conv';

import { ClockIcon, TrashIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "@material-tailwind/react";
import { FaDownload } from "react-icons/fa6";
import { PurchaseOrderModal } from './PurchaseOrderModal';
import DataTableShell from '../../../../Components/table/DataTableShell';
import TableToolbar from '../../../../Components/table/TableToolbar';
import { TableActionGroup, TableIdCell, TableSkeletonRows } from '../../../../Components/table/TableCells';

const TABLE_HEAD = ["Batch ID", "Uploaded by", "PO Number", "Actions"];

export function PurchaseOrderTable() {

  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAltered, setIsAltered] = useState(false);

  const itemsPerPage = 10; 
  const sortedProducts = useMemo(
    () => [...products].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
    [products]
  );
  const totalPages = Math.max(1, Math.ceil(sortedProducts.length / itemsPerPage));
  const safePage = Math.min(currentPage, totalPages);
  const paginatedProducts = sortedProducts.slice((safePage - 1) * itemsPerPage, safePage * itemsPerPage);

  useEffect(() => {
    axios.get('/api/extensive-po-requests/getBatches')
        .then(response => {
            if (response.data.message) {
                console.log("Cannot get batches")
            } else {
              //console.log('Products:', response.data); 
              setProducts(response.data);
            } 
        })
        .catch(error => {
            console.error('Error:', error)
        })
  },[isAltered])

  useEffect(() => {
      const toggleInterval = setInterval(() => {
          setIsAltered(prevState => !prevState)
      }, 2000) 
      return () => {
          clearInterval(toggleInterval)
      }
  }, [])

  const handleAlterState = () => {
    setIsAltered(prevstate => !prevstate);
  };

  const handleDeleteBatch =(batchId) => {
    const isConfirmed = window.confirm(`Are you sure you want to delete this batch: ${batchId}?`)

    if (isConfirmed) {
      axios.delete(`/api/extensive-po-requests/delete/${batchId}`)
        .then(response => {
            if (response.data.message) {
                toast.success(`${response.data.message}`)
                setIsAltered(prevState => !prevState)
            } else {
                toast.error(`${response.data.message}`)
                console.log('Error:', response.data.error)
            }
        })
        .catch(error => {
            console.error('Error:', error)
        }) 
    }
  }

  const generatePOdata = async(batchId) =>{
    await purchaseOrderConverter()
  }

  return (
    <DataTableShell
      minWidth="760px"
      currentPage={safePage}
      setCurrentPage={setCurrentPage}
      totalPages={totalPages}
      toolbar={
        <TableToolbar
          kicker="Extensiv"
          title="Purchase order batches"
          subtitle={`${products.length} total batches · auto refresh every 2 seconds`}
          actions={<PurchaseOrderModal onAlterState={handleAlterState}/>}
        />
      }
    >
          <thead>
            <tr>
              {TABLE_HEAD.map((head) => (
                <th key={head}>{head}</th>
              ))}
            </tr>
          </thead>
          <tbody>
          {products.length <= 0 ?
            <TableSkeletonRows columns={TABLE_HEAD.length} rows={9} />
            :
            (paginatedProducts.map((item) => {
              const date = new Date(item.createdAt);
              const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
              const options = { month: 'long', day: 'numeric', year: 'numeric' };
              const formattedDate = date.toLocaleDateString('en-US', options);
              const formattedDateTime = `${formattedDate} ${formattedTime}`;

              return (
                <tr key={item.batchId}>
                  <td>
                    <div className="flex items-center gap-1">
                      <TableIdCell>{item.batchId}</TableIdCell>
                      <Tooltip content={formattedDateTime}>
                        <ClockIcon className='h-4 w-4 text-muted' />
                      </Tooltip>
                    </div>
                  </td>
                  <td>{item.addedBy}</td>
                  <td className="nx-cell-num">{item.poNumber}</td>
                  <td>
                    <TableActionGroup>
                    <button type="button" className="nx-btn-ghost p-2 text-signal" onClick={() => generatePOdata(item.batchId)} title="Download purchase order"> 
                      <FaDownload className="h-4 w-4" />
                    </button>
                    <button type="button" className="nx-btn-ghost p-2 text-danger" onClick={() => handleDeleteBatch(item.batchId)} title="Delete batch"> 
                      <TrashIcon className="h-4 w-4" />
                    </button>
                    </TableActionGroup>
                  </td>
                </tr>
              );
            }))
          }
          </tbody>
    </DataTableShell>

  );
}

